import * as XLSX from "xlsx";

export const excelExport = (value, name) => {
  const data = XLSX.utils.json_to_sheet(value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, data, "data");
  XLSX.writeFile(wb, name.concat(".xlsx"));
};

export const excelImport = blob => {
  return new Promise(resolve => {
    try {
      const reader = new FileReader();

      reader.onload = event => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data);

        // Assume the first sheet is the one of interest
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert the worksheet to an array of objects
        const xlsxArray = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // Assuming the first row contains headers
        const headers = xlsxArray[0];

        // Rest of the arrays are data
        const rows = xlsxArray.slice(1);

        const result = rows.map(row => {
          const obj = {};

          headers.forEach((header, index) => {
            obj[header] = row[index];
          });

          return obj;
        });

        resolve(result);
      };

      reader.onerror = () => resolve(null);
      reader.readAsArrayBuffer(blob);
    } catch (_) {
      resolve(null);
    }
  });
};
